export default __webpack_public_path__ + "static/media/CTP_Light_FR.2865d21a.svg";